// @mui
import { Stack, Typography } from '@mui/material';
// components
import Title from 'src/components/reporting/Title';
import ImpactGraphs from '../ImpactGraphs';
import SimpleTable from 'src/components/table/SimpleTable';
//
import { ImpactStats, ReportingTooltip } from 'src/resources/api/reports/types.api';

// ----------------------------------------------------------------------

interface Props {
  dataset: ImpactStats;
  previousImpact: ReportingTooltip;
  tableData: any;
  tableConfig: any;
}

const CumulativeImpactSection: React.FC<Props> = ({
  dataset,
  previousImpact,
  tableConfig,
  tableData,
}) => {
  return (
    <Stack spacing={2} sx={{ '& .tileWrapper': { boxShadow: 'none', p: 0 } }}>
      <Title text="Cumulative impact" />
      <Typography variant="body2">
        The graph below shows the cumulative amount of offset carbon emissions since the launch of
        the programme.
      </Typography>
      <ImpactGraphs dataset={dataset} previousImpact={previousImpact} showLineChart />
      <div className="pageBreak" />
      <SimpleTable tableData={tableData} tableConfig={tableConfig} />
    </Stack>
  );
};

export default CumulativeImpactSection;
